import React from "react";
import { connect } from "react-redux";

import { notification } from "antd";

import Layout from "./main";

import { getUserRoles, getUserSession } from "../redux/actions/config/session";
// import { logError } from '../redux/actions/config/log'
import { getHttpClient } from "../api/axiosInstance";

import { APP_VERSION } from "../config/const";

class Secure extends React.Component {
  constructor(props) {
    super(props);
  }

  _logError = async (form) => {
    //await this.props.logError(JSON.stringify(form))

    const apiClient = getHttpClient();

    const url = "/common/error/log";
    const response = await apiClient.post(url, form);
    return response.data;
  };

  componentDidCatch(error, info) {
    // const logger = useLogger()

    const url = window.location.href;

    const { history } = this.props;

    notification.error({
      message: "Error",
      description: "Something went wrong.",
      duration: 5,
    });

    const form = {
      error: `${error?.message} - ${error?.stack}`,
      info: error?.componentStack,
      url,
      user: this.props.user,
      version: APP_VERSION,
    };

    this._logError(form);

    history.push("/app/error/unknown");
  }

  render() {
    return <Layout />;
  }
}

function MapStateToProps(state) {
  return {
    roles: getUserRoles(state),
    user: getUserSession(state),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    // logError: (form) => dispatch(logError(form))
  };
};

export default connect(MapStateToProps, mapDispatchToProps)(Secure);
